import React from 'react';
import { ChevronDownIcon } from '@rsos/base-assets/icons';
import { Box, Text } from '@rsos/base-components';
import { RotatedButton } from '../ChatCard/LiveChatCard.styles';
import { CardOverlay } from '../tabs/OverviewTab/OverviewTab.styles';

interface PreviousCallsCardProps {
  previousCallsCount: number;
  onClick: () => void;
}

/**
 * Previous Calls card component that is displayed on the overview tab when there are recent transcripts.
 */
const PreviousCallsCard = ({
  previousCallsCount,
  onClick,
}: PreviousCallsCardProps) => {
  const displayText =
    previousCallsCount === 1
      ? `${previousCallsCount} previous call from this number`
      : `${previousCallsCount} previous calls from this number`;

  return (
    <CardOverlay data-name="previous-calls-card" onClick={onClick}>
      <Box horizontal justify="space-between" align="center">
        <Box>
          <Text
            color="primaryText"
            data-name="previous-calls-text"
            fontWeight="bold"
            size="normal"
          >
            {displayText}
          </Text>
        </Box>

        <Box width="24px">
          <RotatedButton btnType="secondary" size="xsmall" noMargin>
            <ChevronDownIcon width={10} height={10} />
          </RotatedButton>
        </Box>
      </Box>
    </CardOverlay>
  );
};

export default PreviousCallsCard;
